import { Button, Modal, Form } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import Select from "react-select"; // ✅ Importar react-select

const ModalMedicamentos = (props) => {
  const { estado, onCloseModal, item, onReturnValue, isnew } = props;

  const [formData, setFormData] = useState({
    nombre: "",
    principioActivo: "",
    formaFarmaceutica: "",
    concentracion: "",
    presentacion: "",
    unidadMedida: "",
    laboratorio: "",
    observacion: "",
  });

  // 🔹 Lista ampliada de unidades de medida médicas comunes
  const unidades = [
    { value: "ml", label: "Mililitros (ml)" },
    { value: "l", label: "Litros (L)" },
    { value: "mg", label: "Miligramos (mg)" },
    { value: "g", label: "Gramos (g)" },
    { value: "mcg", label: "Microgramos (mcg)" },
    { value: "kg", label: "Kilogramos (kg)" },
    { value: "mEq", label: "Miliequivalentes (mEq)" },
    { value: "UI", label: "Unidades Internacionales (UI)" },
    { value: "ampolla", label: "Ampolla" },
    { value: "vial", label: "Vial" },
    { value: "frasco", label: "Frasco" },
    { value: "tableta", label: "Tableta" },
    { value: "tabletas", label: "Tabletas" },
    { value: "capsula", label: "Cápsula" },
    { value: "capsulas", label: "Cápsulas" },
    { value: "pastilla", label: "Pastilla" },
    { value: "pastillas", label: "Pastillas" },
    { value: "comprimido", label: "Comprimido" },
    { value: "comprimidos", label: "Comprimidos" },
    { value: "sobre", label: "Sobre" },
    { value: "sobres", label: "Sobres" },
    { value: "dosis", label: "Dosis" },
    { value: "puff", label: "Puff (inhalaciones)" },
    { value: "gota", label: "Gota" },
    { value: "gotas", label: "Gotas" },
    { value: "unidad", label: "Unidad" },
    { value: "unidades", label: "Unidades" },
    { value: "parche", label: "Parche" },
    { value: "parches", label: "Parches" },
    { value: "cc", label: "Centímetros cúbicos (cc)" },
    { value: "tubo", label: "Tubo" },
    { value: "ampollas", label: "Ampollas" },
    { value: "jeringa", label: "Jeringa" },
    { value: "jeringas", label: "Jeringas" },
    { value: "spray", label: "Spray" },
    { value: "dispositivo", label: "Dispositivo médico" },
    { value: "kit", label: "Kit" },
    { value: "bolsa", label: "Bolsa" },
    { value: "bolsas", label: "Bolsas" },
  ];

  useEffect(() => {
    if (item) {
      setFormData({
        nombre: item.nombre || "",
        principioActivo: item.principioActivo || "",
        formaFarmaceutica: item.formaFarmaceutica || "",
        concentracion: item.concentracion || "",
        presentacion: item.presentacion || "",
        unidadMedida: item.unidadMedida || "",
        laboratorio: item.laboratorio || "",
        observacion: item.observacion || "",
        idMedicamento: item.idMedicamento || null,
      });
    }
  }, [item]);

  // 🔹 Convierte a mayúsculas excepto unidad de medida
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name !== "unidadMedida") {
      newValue = value.toUpperCase();
    }
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // 🔹 Manejo del select de unidad de medida
  const handleUnidadChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      unidadMedida: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onReturnValue(formData, isnew);
  };

  return (
    <Modal show={estado} onHide={onCloseModal} size="lg" centered>
      <Form onSubmit={handleSubmit} id="formMedicamento">
        <Modal.Header closeButton>
          <Modal.Title>
            {isnew ? "AGREGAR MEDICAMENTO" : "EDITAR MEDICAMENTO"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Nombre *</Form.Label>
                <Form.Control
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Ej: PARACETAMOL"
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Principio Activo *</Form.Label>
                <Form.Control
                  name="principioActivo"
                  value={formData.principioActivo}
                  onChange={handleChange}
                  required
                  placeholder="Ej: ACETAMINOFÉN"
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Forma Farmacéutica *</Form.Label>
                <Form.Control
                  name="formaFarmaceutica"
                  value={formData.formaFarmaceutica}
                  onChange={handleChange}
                  required
                  placeholder="Ej: TABLETA, JARABE, POMADA"
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Concentración *</Form.Label>
                <Form.Control
                  name="concentracion"
                  value={formData.concentracion}
                  onChange={handleChange}
                  required
                  placeholder="Ej: 250 mg/5ml"
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Presentación *</Form.Label>
                <Form.Control
                  name="presentacion"
                  value={formData.presentacion}
                  onChange={handleChange}
                  required
                  placeholder="Ej: FRASCO 250ML"
                />
              </Form.Group>
            </div>

            {/* ✅ react-select */}
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Unidad de Medida *</Form.Label>
                <Select
                  options={unidades}
                  placeholder="Seleccione o busque una unidad..."
                  value={
                    unidades.find((u) => u.value === formData.unidadMedida) ||
                    null
                  }
                  onChange={handleUnidadChange}
                  isClearable
                  isSearchable
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: "#ced4da",
                      boxShadow: "none",
                    }),
                  }}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Laboratorio</Form.Label>
                <Form.Control
                  name="laboratorio"
                  value={formData.laboratorio}
                  onChange={handleChange}
                  placeholder="Ej: BAYER, ROEMMERS"
                />
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group>
                <Form.Label>Observación</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="observacion"
                  value={formData.observacion}
                  onChange={handleChange}
                  placeholder="Observaciones adicionales"
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={onCloseModal}>
            Cerrar
          </Button>
          <Button variant="primary" type="submit">
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalMedicamentos;
